/* eslint-disable @next/next/no-img-element */
import classNames from 'classnames';
import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import { getImageKitUrl } from 'core-lib/utils/imageKit';
import { useEffect, useRef, useState } from 'react';
import AnimatedImage from 'core-lib/components/AnimatedImage';
import { Typography } from 'ui-v2/components/Typography';
import useStoreItemClick from '../../../hooks/useStoreItemClick';
import { LayoutPropType } from '../../../types/layout';
import { trackSectionViewedStoreV2 } from '../../../utils/events';
import s from './TrendingDeals.module.scss';
import dynamic from 'next/dynamic';

const Swiper = dynamic(() => import('core-lib/components/Swiper'), {
  ssr: false,
});

export const TrendingDeals = ({ data }: LayoutPropType) => {
  // state
  const [renderItem, setRenderItem] = useState(false);

  //const
  const rootRef = useRef();
  const isEventFired = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 0.5,
  });
  const { handleItemClickWithDelegation } = useStoreItemClick();
  const CARDID = data.layoutType;

  useEffect(() => {
    if (inViewPort && !isEventFired.current) {
      trackSectionViewedStoreV2(data?.title);
      isEventFired.current = true;
    }
  }, [data?.title, inViewPort]);

  useEffect(() => {
    const id = setTimeout(() => {
      setRenderItem(true);
    }, 1000);

    return () => clearTimeout(id);
  }, []);

  return (
    <div
      className={s.root}
      ref={rootRef}
      onClick={(e) => {
        handleItemClickWithDelegation(
          e,
          CARDID,
          data.entityType,
          data.data,
          data?.title
        );
      }}
    >
      {!renderItem && (
        <div className={s.shimmer}>
          <div className={classNames(s.card_1, 'cmn_shimmer')} />
          <div className={classNames(s.card_2, 'cmn_shimmer')} />
          <div className={classNames(s.card_3, 'cmn_shimmer')} />
        </div>
      )}
      <Typography
        label={data?.title}
        variant="label_2_bold"
        className={s.title}
      />
      <div className={s.container}>
        <Swiper
          effect="coverflow"
          coverflowEffect={{
            rotate: 0,
            stretch: 10,
            depth: 40,
            modifier: 4,
          }}
          slidesPerView={2}
          centeredSlides
          style={{ height: '250px' }}
          slides={data?.data?.map((item, id) => (
            <div
              key={id}
              className={s.card}
              id={CARDID}
              data-index={id}
              aria-hidden
            >
              <AnimatedImage
                loading="eager"
                src={getImageKitUrl({
                  imageUrl: item?.coverImage,
                  width: 500,
                })}
                alt="coverImage"
              />
            </div>
          ))}
        />
      </div>
    </div>
  );
};
